import axios from 'axios'
import store from '../store'
import * as types from '../store/mutation-types'
import router from '../router'
import i18n from '../plugins/i18n'

import {Notify} from 'quasar-framework'

// Request interceptor
axios.interceptors.request.use(request => {
    const token = store.getters['auth/token']
    if (token)
        request.headers.common['Authorization'] = `Bearer ${token}`

    const locale = store.getters['lang/locale']
    if (locale)
        request.headers.common['Accept-Language'] = locale

    // request.headers['X-Socket-Id'] = Echo.socketId()

    return request
})

// Response interceptor
axios.interceptors.response.use(response => response, error => {
    const {status} = error.response

    let url = ''
    if (error.response.config)
         url = error.response.config.url

    if (status >= 500) {
        Notify.create({
            color: 'negative',
            icon: 'error',
            message: i18n.T('an error has ocurred'),
            detail: `${i18n.T('something went wrong!')} ${i18n.T('please try again.')}`,
            position: 'bottom'
        })
    }

    if (status === 401 && store.getters['auth/check'] && url != '/api/logout') {
        Notify.create({
            color: 'warning',
            icon: 'warning',
            message: i18n.T('session expired!'),
            detail: i18n.T('please log in again to continue.'),
            position: 'bottom',
            actions: [{
                label: i18n.T('go to login page'),
                handler() {
                    store.dispatch('auth/logout').then(() => {
                        this.$login("desporto")
                    })
                }
            }]
        })
    }

    if (status == 403) {
        Notify.create({
            color: 'negative',
            icon: 'error',
            message: i18n.T('forbidden'),
            detail: i18n.T('You don\'t have permission to access!'),
            position: 'bottom',
            actions: [{
                label: i18n.T('go to home page'),
                handler() {
                    router.push({name: 'sports'})
                }
            }]
        })
    }

    return Promise.reject(error)
})


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/axios.js